/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
// import HomeTopPlaces from "../../components/TopPlaces/HomeTopPlaces";
import {
  Container,
  Breadcrumb,
  BreadcrumbItem,
  // InputGroup,
  // InputGroupText,
  // Input,
  Button,
} from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import { IoIosSearch } from "react-icons/io";
import GridView from "./GridView";
import TableView from "./TableView";
import "../Category/Cemetery/Cemetery.scss";
import { useSelector, useDispatch } from "react-redux";
import { getUserFavourites } from "../../services/favourites.service";
import { changeView, hideLoader, showLoader } from "../../utils/action/Action";
import useDebounce from "../../components/Debounce/Debounce";
import { toast } from "react-toastify";
import { MdGridOn, MdOutlineNavigateNext } from "react-icons/md";
import { FiList } from "react-icons/fi";
import ContainerLayout from "../../layout/ContainerLayout";
import { GoHome } from "react-icons/go";
import swal from "sweetalert";

function Favourites({ isUserLoggedIn }) {
  const [viewName, setViewname] = useState("grid");
  const [favourite, setFavourite] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const [totalCount, setTotalCount] = useState();
  const [debouceValue, setDebouceValue] = useState("");
  const [values, setValues] = useState({
    search: "",
  });

  const dispatch = useDispatch();
  const debounce = useDebounce();
  const navigate = useNavigate();
  var regex =
    /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g;

  const userName = useSelector(
    (state) => state.userDetailReducer.userData.userName,
  );
  const current_value = useSelector(
    (state) => state?.changeViewReducer?.current_view,
  );

  useEffect(() => {
    setTimeout(() => {
      window?.scrollTo({ top: 0, behavior: "smooth" });
    }, 0);
  }, []);

  useEffect(() => {
    current_value === "table"
      ? setViewname("table")
      : current_value === "grid"
        ? setViewname("grid")
        : setViewname("map");
  }, [current_value]);

  useEffect(() => {
    if (values?.search?.length > 0) {
      if (values?.search?.length > 2) {
        getFavouriteList();
      } else {
        toast.info("Please enter atleast 3 characters to get result.", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000,
        });
      }
    } else {
      if (isUserLoggedIn) {
        getFavouriteList();
      } else {
        const notLoggedIn = swal({
          title: "Please Continue to Log In",
          text: "You want access your favorites ?",
          icon: "warning",
          buttons: ["Cancel", "Log In"],
        });
        if (notLoggedIn) {
          navigate("/sign-in");
        }
      }
    }
  }, [debouceValue, currentPage, pageSize]);

  const getFavouriteList = async () => {
    if (isUserLoggedIn) {
      dispatch(showLoader());
      try {
        const response = await getUserFavourites({
          userName: userName,
          pageNumber: currentPage,
          pageSize: pageSize,
          filter: values?.search?.trim(),
        });
        if (response && response?.status === 200) {
          setFavourite(response?.data?.data?.data);
          setCurrentPage(response?.data?.data?.pageNumber);
          setPageSize(pageSize);
          setTotalCount(response?.data?.data?.totalCount);
        }
        dispatch(hideLoader());
      } catch {
        dispatch(hideLoader());
      }
    }
  };

  const handleClick = (view) => {
    dispatch(changeView(view));
    setViewname(view);
  };

  const handleSearch = (e) => {
    const newData = { ...values };
    newData[e?.target?.id] = e?.target?.value
      ?.replace(/^\s+/, "")
      .replace(regex, "");
    setValues(newData);
    debounce(() => setDebouceValue(newData));
  };

  return (
    <div className="main_section cemetery">
      <>
        {/* <SearchBar /> */}
        {/* <HomeTopPlaces /> */}
        <div className="myroutes_section">
          <div className="breadcrumb_section">
            <Container>
              <Breadcrumb className="nt-breadcrumb">
                <Link to="/" className="breadcrumb_item1">
                  <GoHome className="home_icon" />
                </Link>
                <span className="breadcrumb-divider">
                  <MdOutlineNavigateNext />
                </span>
                <BreadcrumbItem active>
                  <Link to="/favourites" className="breadcrumb_item2">
                    Favourites
                  </Link>
                </BreadcrumbItem>
              </Breadcrumb>
            </Container>
          </div>
          <ContainerLayout classes={{ maxWidth: "1300px" }}>
            <div className="myroutes_box">
              <div className="myroutes_heading">
                <h4 style={{ fontSize: "40px", fontFamily: "Lato" }}>
                  Favourites
                </h4>
              </div>

              <div className="header_bottom">
                <div className="left_side">
                  <div className="search_input">
                    <IoIosSearch className="icon" />
                    <input
                      type="text"
                      id="search"
                      name="search"
                      // placeholder={`Search in ${categoryName}`}
                      value={values?.search}
                      onChange={handleSearch}
                      maxLength="100"
                      autoComplete="off"
                    />
                  </div>
                </div>
                <div className="buttons_section">
                  <div className="view_btns">
                    <Button
                      name="grid"
                      className={`${
                        viewName === "grid" ? "btn_grid" : "btn_table"
                      }`}
                      onClick={() => handleClick("grid")}
                    >
                      <MdGridOn />
                      Grid View
                    </Button>
                    <Button
                      name="table"
                      className={`${
                        viewName === "table" ? "btn_grid" : "btn_table"
                      }`}
                      onClick={() => handleClick("table")}
                    >
                      <FiList />
                      Table View
                    </Button>
                  </div>
                </div>
              </div>
              <div className="myroutes_block">
                {viewName === "grid" ? (
                  <GridView
                    favourite={favourite}
                    getFavouriteList={getFavouriteList}
                    totalCount={totalCount}
                    pageSize={pageSize}
                    setCurrentPage={setCurrentPage}
                    currentPage={currentPage}
                    isUserLoggedIn={isUserLoggedIn}
                  />
                ) : viewName === "table" ? (
                  <TableView
                    favourite={favourite}
                    getFavouriteList={getFavouriteList}
                    totalCount={totalCount}
                    pageSize={pageSize}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    setPageSize={setPageSize}
                    isUserLoggedIn={isUserLoggedIn}
                  />
                ) : (
                  <>
                    {/* <MapView favourite={favourite} /> */}
                    <GridView
                      favourite={favourite}
                      getFavouriteList={getFavouriteList}
                      totalCount={totalCount}
                      pageSize={pageSize}
                      setCurrentPage={setCurrentPage}
                      currentPage={currentPage}
                      isUserLoggedIn={isUserLoggedIn}
                    />
                  </>
                )}
              </div>
            </div>
          </ContainerLayout>
        </div>
      </>
    </div>
  );
}

export default Favourites;
